// ======================================================================
// File Name       : loginHistory
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { callPythonApi } from '../../utils/ApiUtils';
import { downloadFile } from '../../utils/index';

export function postGetEnterpriseLoginHistoryData(data) {
  return callPythonApi({
    path: 'cms/user/get-enterprise-login-history-data',
    data: { ...data },
  }).then((camelizeJson) => {
    const url = camelizeJson && camelizeJson.zipfileUrl ? camelizeJson.zipfileUrl : null;
    downloadFile(url);
  });
}

export function postGetServiceLoginHistoryData(data) {
  return callPythonApi({
    path: 'cms/user/get-service-login-history-data',
    data: { ...data },
  }).then((camelizeJson) => {
    const url = camelizeJson && camelizeJson.zipfileUrl ? camelizeJson.zipfileUrl : null;
    downloadFile(url);
  });
}
